import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';
import { Filter } from './filter';
import { SessionsFilter } from '@data/filter/filters/sessions.filter';
import { AttendantsFilter } from '@data/filter/filters/attendants.filter';
import createInitialAttendantFilterState = AttendantsFilter.createInitialAttendantFilterState;
import createInitialSessionsFilterState = SessionsFilter.createInitialSessionsFilterState;

/** Filter type selection for different tables. */
export type FilterTarget = 'sessions' | 'attendants';

export type FilterState = {
  [key in FilterTarget]: Filter<any, any>[];
};

export function deserialize(persistState: any) {
  return {
    sessions: createInitialSessionsFilterState(persistState?.sessions ?? []),
    attendants: createInitialAttendantFilterState(persistState?.attendants ?? []),
  };
}

export function createInitialState(): FilterState {
  return {
    sessions: createInitialSessionsFilterState([]),
    attendants: createInitialAttendantFilterState([]),
  };
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'filter' })
export class FilterStore extends Store<FilterState> {
  constructor() {
    super(createInitialState());
  }
}
